import { render, staticRenderFns } from "./LayoutIndex.vue?vue&type=template&id=44021e0c"
import script from "./LayoutIndex.vue?vue&type=script&lang=js"
export * from "./LayoutIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports